module.exports = "/build/images/icons-public.0cc642c7.svg";